import { Dispatch } from "react";
import { ApiConfig } from "../../Config/CommonConfig";
import { GETAPI, POSTAPI, POSTASFORMDATA } from "../../API/Api";
import {
  SKILLS_ADMIN_LIST_FAIL,
  SKILLS_ADMIN_LIST_REQUEST,
  SKILLS_ADMIN_LIST_SUCCESS,
  SKILLS_CSV_UPLOAD_FAIL,
  SKILLS_CSV_UPLOAD_REQUEST,
  SKILLS_CSV_UPLOAD_SUCCESS,
  SKILLS_BULK_VERIFY_FAIL,
  SKILLS_BULK_VERIFY_REQUEST,
  SKILLS_BULK_VERIFY_SUCCESS,
  SKILLS_MANUAL_UPLOAD_FAIL,
  SKILLS_MANUAL_UPLOAD_REQUEST,
  SKILLS_MANUAL_UPLOAD_SUCCESS,
} from "../../Constants/SkillConstants";

export const SkillsAdminListAction =
  (queryParams: string) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: SKILLS_ADMIN_LIST_REQUEST });

      const data = await GETAPI(ApiConfig?.SkillsAdminList + queryParams);

      if (data && data?.status === true) {
        dispatch({
          type: SKILLS_ADMIN_LIST_SUCCESS,
          data: data?.data,
        });
      } else {
        dispatch({
          type: SKILLS_ADMIN_LIST_FAIL,
          data: { row: [], total_count: 0, count: 0 },
        });
      }
    } catch (error) {
      dispatch({
        type: SKILLS_ADMIN_LIST_FAIL,
        data: { row: [], total_count: 0, count: 0 },
      });
    }
  };

export const SkillsManualUploadAction =
  (skills: string[]) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: SKILLS_MANUAL_UPLOAD_REQUEST });
      const payload = { skills };
      const data = await POSTAPI(ApiConfig?.SkillsManualUpload, payload, true);

      if (data && data?.status === true) {
        dispatch({
          type: SKILLS_MANUAL_UPLOAD_SUCCESS,
          data: data?.data,
        });
        return data;
      } else {
        dispatch({
          type: SKILLS_MANUAL_UPLOAD_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: SKILLS_MANUAL_UPLOAD_FAIL,
        data: null,
      });
      return null;
    }
  };

export const SkillsCsvUploadAction =
  (file: File) => async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: SKILLS_CSV_UPLOAD_REQUEST });
      const formData = new FormData();
      formData.append("file", file);

      const data = await POSTASFORMDATA(
        ApiConfig?.SkillsCsvUpload,
        formData,
        true
      );

      if (data && data?.status === true) {
        dispatch({
          type: SKILLS_CSV_UPLOAD_SUCCESS,
          data: data?.data,
        });
        return data;
      } else {
        dispatch({
          type: SKILLS_CSV_UPLOAD_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: SKILLS_CSV_UPLOAD_FAIL,
        data: null,
      });
      return null;
    }
  };

export const SkillsBulkVerifyAction =
  (skills: number[], isVerified: boolean) =>
  async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: SKILLS_BULK_VERIFY_REQUEST });
      const payload = { skills, is_verified: isVerified };
      const data = await POSTAPI(ApiConfig?.SkillsBulkVerify, payload, true);

      if (data && data?.status === true) {
        dispatch({
          type: SKILLS_BULK_VERIFY_SUCCESS,
          data: data?.data,
        });
        return data;
      } else {
        dispatch({
          type: SKILLS_BULK_VERIFY_FAIL,
          data: null,
        });
        return data;
      }
    } catch (error) {
      dispatch({
        type: SKILLS_BULK_VERIFY_FAIL,
        data: null,
      });
      return null;
    }
  };
